import FileModel from "../../models/FileModel";
import { getShortFileSize } from "../../helpers/converters/fileHelpers";
import CountryModel from "../../models/CountryModel";
import LocationModel from "../../models/LocationModel";
import { dateFormatted } from "../../helpers/timeHelpers";
import { extractUserFullName } from "../../helpers/userHelper";

function extractPlaceData(
  file: FileModel,
  allCountryList: CountryModel[],
  allLocationList: LocationModel[],
) {
  const fileLink = file.fileLink;
  const locations = fileLink?.locations || [];
  const buildings = fileLink?.buildings || [];

  if (locations.length > 0) {
    const location = locations[0];
    const foundCountry = allCountryList.find((country) => country.id === location.countryId);

    return {
      countryId: foundCountry?.id,
      country: foundCountry?.name || '-',
      locations: locations.map((location) => location.name).join(', '),
      buildings: '*'
    };
  }

  if (buildings.length > 0) {
    const building = buildings[0];
    const foundLocation = allLocationList.find((location) => location.id === building.locationId);
    const foundCountry = allCountryList.find((country) => country.id === foundLocation?.countryId);

    return {
      countryId: foundCountry?.id,
      country: foundCountry?.name || '-',
      locationId: foundLocation?.id,
      locations: foundLocation?.name || '-',
      buildings: buildings.map((building) => building.name).join(', '),
    };
  }

  return {};
}

export function extractFilesData(
  file: FileModel | undefined | null,
  allCountryList: CountryModel[],
  allLocationList: LocationModel[],
) {
  if (!file) {
    return;
  }

  const viewModel = {
    id: file.id,
    name: file.name,
    size: getShortFileSize(file.size),
    uploadDate: dateFormatted(file.creationDate),
    uploadedBy: extractUserFullName(file.fileLink?.user),
    ...extractPlaceData(file, allCountryList, allLocationList),
  }

  return viewModel;
}